import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { DEFAULT_LANG, LANGS } from "~/lib/i18nConfig";
import type { Lang } from "~/data/i18n";

interface UiState {
  lang: Lang;
  theme: "light" | "dark";
  density: "comfortable" | "compact";
  drawerOpen: boolean;
  setLang: (l: Lang) => void;
  setTheme: (t: "light" | "dark") => void;
  setDensity: (d: "comfortable" | "compact") => void;
  toggleDrawer: () => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      lang: DEFAULT_LANG,
      theme: "light",
      density: "comfortable",
      drawerOpen: false,
      setLang: (l) => {
        if (!LANGS.includes(l)) return;
        set({ lang: l });
      },
      setTheme: (t) => set({ theme: t }),
      setDensity: (d) => set({ density: d }),
      toggleDrawer: () => set((s) => ({ drawerOpen: !s.drawerOpen })),
    }),
    {
      name: "fnd.lang",
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ lang: s.lang }),
      // sanitize stale value outside active subset on hydration
      onRehydrateStorage: () => (state) => {
        if (state && !LANGS.includes(state.lang)) state.lang = DEFAULT_LANG;
      },
    },
  ),
);
